import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router'
import { ReactSVG } from 'react-svg'

import { URL_CUSTOMER_PROFILE } from '@shared/contants'

import styles from './styles.module.scss'

interface ItemProps {
  path: string;
  activePath: string | undefined;
  isTablet: boolean;
  onClick: () => void;
}

export default function Item ({
  path,
  activePath,
  isTablet,
  onClick,
}: ItemProps) {
  const { t: tn } = useTranslation('personal')
  return (
    <NavLink
      onClick={() => (isTablet ? onClick() : null)}
      className={classNames(styles.item, {
        [styles['item--active']]: !isTablet && path === activePath,
      })}
      to={`${URL_CUSTOMER_PROFILE}/${path}`}
    >
      <ReactSVG src={`/icons/personal-nav/${path}.svg`} />
      {tn(`nav.${path}`)}
    </NavLink>
  )
}
